export default "__VITE_ASSET__8fcf9510__"